import React from 'react'
import assetPage from '../common/assets/asset-pic.png'

export default function Audit() {
  return (
    <div style={{textAlign: 'center'}}>
      <img src={assetPage} alt="asset page" />
    </div>
  )
}
